/**
 * HuisBuffer add-to-cart via the Cart AJAX API.
 *
 * The custom PDP sections (hb-core / hb-modulaire-batterij /
 * hb-uitbreidingsmodule / hb-wielenset) post their add-to-cart form with a
 * full-page POST to /cart/add. That navigation bypasses the AJAX Cart API, so
 * Shopify's first-party web pixel never sees the add and `product_added_to_cart`
 * never fires (0 "Added to cart" in Analytics).
 *
 * This binds those forms (marked `data-cart-form`) and adds via
 * fetch(routes.cart_add_url) — the same call Dawn's product-form.js makes — so
 * the pixel fires. UX is preserved: on success we navigate to the cart page,
 * exactly like the original full-page submit did. On any failure we fall back
 * to the native submit so nothing is lost.
 */
(function () {
  var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var cartJsonUrl = (cartUrl.split('?')[0]).replace(/\/$/, '') + '.js';

  // After a successful AJAX add, dispatch the same Shopify Standard Event that
  // Dawn's product-form.js fires. This is what Shopify turns into the
  // `product_added_to_cart` customer event, which the Meta pixel (Facebook &
  // Instagram channel) maps to AddToCart. A bare fetch to /cart/add is tracked
  // server-side (Shopify Analytics) but never emits this client-side event, so
  // without this dispatch Meta sees no AddToCart. We navigate to the cart only
  // after the event's promise settles, giving the pixel sandbox time to process.
  function dispatchCartAdd(form) {
    var StandardEvents = window.StandardEvents || {};
    var CartLinesUpdateEvent = StandardEvents.CartLinesUpdateEvent;
    if (!CartLinesUpdateEvent) return Promise.resolve();

    var data = new FormData(form);
    var variantId = data.get('id');
    var quantity = parseInt(data.get('quantity'), 10) || 1;
    if (!variantId) return Promise.resolve();

    var deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: quantity }],
        promise: deferred.promise,
      })
    );

    // Resolve the event with the full cart state, mirroring Dawn's
    // resolveCartLinesUpdate (product-form.js). We swallow errors: a failed
    // resolve must not block the redirect the shopper expects.
    return fetch(cartJsonUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cart || !cart.currency) throw new Error('missing-cart');
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
      })
      .catch(function (error) {
        deferred.reject(error);
      });
  }

  function bind(form) {
    if (form.dataset.hbAddBound) return;
    form.dataset.hbAddBound = 'true';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var button = form.querySelector('[type="submit"]');
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
      }

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add-failed');
          // Add succeeded. Fire the Standard Event so the Meta pixel registers
          // AddToCart, then navigate once it settles.
          return dispatchCartAdd(form).then(function () {
            window.location.href = cartUrl;
          });
        })
        .catch(function () {
          // Out of stock / network / etc. — let the native submit take over so
          // the shopper still gets Shopify's normal response.
          if (button) {
            button.removeAttribute('aria-busy');
            button.disabled = false;
          }
          form.submit();
        });
    });
  }

  function init() {
    document.querySelectorAll('form[data-cart-form]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
